import React from 'react';
import orgConfig from 'org/configs/org.config';
import { InstoreRebate } from 'core/modules/Instore2/partials';

const { instoreLabel } = orgConfig;

function OfferRebate({ offer }) {
  const { hasLinkedCards } = offer;

  return (
    <div className="mn_rebateInfo">
      <p className="mn_preRebateText">{hasLinkedCards ? <>Shop {instoreLabel} and</> : <>Link offer and</>}</p>
      <InstoreRebate offer={offer} />
    </div>
  );
}

export default OfferRebate;
